// Component: Button
// Author: Jay
import * as React from 'react';
import ButtonNPM from '@rotaryintl/component-button';
import { Text } from '@sitecore-jss/sitecore-jss-react';

export default function Button(props) {
  return (
    <>
      {props.fields?.ButtonText && props.fields?.ButtonText.value ? (
        <ButtonNPM url={props.fields?.ButtonLink?.value.url}>
          <Text field={props.fields?.ButtonText} />
        </ButtonNPM>
      ) : null}
    </>
  );
}
